import { Button, Card, ConfigProvider, Flex, Table } from "antd";
// import {style} from ".";
import cx from "classnames";
import styles from "./Input.module.css";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

function TableAntd(
  {
    loading = false,
    pagination = {},
    itemRender = null,
    dataSource = [],
    columns = [],
    onChange = () => { },
    expandable = {},
    scroll = {},
    rowKey = null,
    noPage = false,
    rowSelection = false,
    tableLayout = "",
    onRowClick = () => { },
    className = "",
    components = {},
  }) {
  const { t } = useTranslation();

  const tableRef = useRef(null);

  // This effect will scroll the table container to top when pagination changes
  useEffect(() => {
    if (pagination.current && tableRef.current) {
      // Option 1: Scroll the table container to top
      if (tableRef.current.getElementsByClassName('ant-table-body')[0]) {
        tableRef.current.getElementsByClassName('ant-table-body')[0].scrollTop = 0;
      }

      // Option 2: Or scroll the window to the table's position
      // tableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [pagination.current]);

  // Custom handler for pagination changes
  const handleTableChange = (paginationObj, filters, sorter, extra) => {
    // Call the original onChange handler
    onChange(paginationObj, filters, sorter, extra);

    // Scroll to the top of the table
    if (tableRef.current) {
      // Delay the scroll slightly to let the table re-render
      setTimeout(() => {
        window.scrollTo({
          top: tableRef.current.offsetTop - 20,
          behavior: 'smooth'
        });
      }, 100);
    }
  };

  const arrowLeft = () => {
    return <Button type="default" style={{ height: "36px" }}>
      <Flex gap={5} style={{
        placeItems: 'center'
      }}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.8334 9.99996H4.16669M4.16669 9.99996L10 15.8333M4.16669 9.99996L10 4.16663" stroke="#667085" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span style={{ color: "#667085" }}>{t('prev')}</span>
      </Flex>
    </Button>
  }
  const arrowRight = () => {
    return <Button type="default" style={{ height: "36px" }}>
      <Flex gap={5} style={{
        placeItems: 'center'
      }}>
        <span style={{ color: "#667085" }}>{t('next')}</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.16666 9.99996H15.8333M15.8333 9.99996L9.99999 4.16663M15.8333 9.99996L9.99999 15.8333" stroke="#667085" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </Flex>
    </Button>
  }

  return <Card styles={{ body: { padding: 0 } }}>
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: "#F5F6F7"
          },
        },
      }}
    >
      <div ref={tableRef}>
        <Table
          // style={{
          //   height: "50vh"
          // }}
          className={cx(className, styles.table)}
          onRow={
            (record, rowIndex) => {
              return {
                onClick: onRowClick
              };
            }
          }
          loading={loading}
          pagination={noPage ? false : {
            className: styles.pagination, // Add this line
            position: ['bottomCenter'],
            itemRender: itemRender ? itemRender : (e, v, elements) => {
              if (v == 'prev' || v == 'next')
                return v == 'prev' ? arrowLeft() : arrowRight()
              else return elements
            },
            ...pagination,
            showTotal: false,
            showLessItems: true,
            showSizeChanger: false
          }}
          rowKey={rowKey}
          expandable={expandable}
          dataSource={dataSource}
          columns={columns}
          onChange={handleTableChange}
          scroll={{ ...scroll }}
          rowSelection={rowSelection}
          tableLayout={tableLayout}
          components={components}
          style={{ border: "1px solid #EFF1F4", borderRadius: "8px" }} />
      </div>
    </ConfigProvider>
  </Card>;
}

export default TableAntd;
